import Tabs from 'components/tabs'
import { useEffect } from 'react'
import { Tab } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { IStatusData } from 'services/type'
import { setStatus } from 'store/artist/artistSlice'
import { selectArtist } from 'store/artist/selectors'

export default function ArtistHeader() {
  const { status, isLoading } = useSelector(selectArtist)
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const listStatus: Array<string | number> = Object.keys(IStatusData)
    .map((key) => IStatusData[key as any])
    .filter((key) => typeof key === 'number')

  function getNameOfStatus(status?: IStatusData) {
    switch (status) {
      case IStatusData.PENDING:
        return 'PENDING_REQUEST'
      case IStatusData.APPROVED:
        return 'APPROVED'
      case IStatusData.DISAPPROVED:
        return 'DISAPPROVED'
      default:
        return undefined
    }
  }

  useEffect(() => {
    return () => {
      dispatch(setStatus(IStatusData.PENDING))
    }
  }, [])

  return (
    <div className='wa__header'>
      <Tabs
        transition={false}
        onSelect={(eve: any) => {
          if (!isLoading) dispatch(setStatus(eve))
        }}
        activeKey={status}
        defaultActiveKey={status}
        className='me-auto'
      >
        {listStatus.map((key, i) => (
          <Tab
            key={i}
            eventKey={key}
            title={t(getNameOfStatus(key as any) || '')}
          />
        ))}
      </Tabs>
    </div>
  )
}
